module.exports = __webpack_public_path__ + "img/urc.720e6b63.jpg";